import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = [ 'tag', 'textarea']

  add(event) {
    this.textareaTarget.value += event.target.textContent
  }
}
